export default __webpack_public_path__ + "static/media/delete.b75d5dbc.svg";